import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { useHasPermission } from "lib/hooks/permissions";

const AuthWrapper = ({ permission, children, clientId }) => {
  const { authObject } = useSelector(({ authReducer }) => authReducer);

  const hasAccess = useHasPermission(permission, clientId);

  if (authObject && hasAccess) {
    const hasRoles = (authObject.isAdmin && authObject.roles && authObject.roles.length) || 
                     (authObject.clientRoles && authObject.clientRoles.length > 0);
        
    if (hasRoles) {
      return children;
    }
  }
  
  return null;
};

AuthWrapper.propTypes = {
  permission: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  clientId: PropTypes.string,
};

export default AuthWrapper;
